// Inspired by http://sandbox.timbenniks.com/projects/jquery-notice/
(function($) {
	// Dynamically include some CSS
	var css = '<style id="origin-notice" type="text/css">' +
				'#origin-notice-wrapper { position: fixed; z-index: 10000; top: 20px; right: 20px; width: 250px; }' +
				'* html #origin-notice-wrapper { position: absolute; }' +
				'div.origin-notice { font-size: 14px; font-style: italic; cursor: pointer; opacity: 0.95; ' +
					'filter: alpha(opacity=95); border: 2px solid #FFF; margin: 0; padding: 4px 8px; border-radius: 5px; ' +
					'-moz-border-radius: 5px; -webkit-border-radius: 5px; }' +
				'div.origin-notice-close { padding-right: 20px; }' +
				'#origin-notice-wrapper div.origin-notice { position: relative; margin-bottom: 10px; padding-right: 20px; font-size: 12px; font-style: normal;  }' +
				'div.origin-notice-success { background-color: #50CC50; color: #FFF; }' +
				'div.origin-notice-error { background-color: #CC5050; color: #FFF; }' +
				'div.origin-notice-info { background-color: #5050CC; color: #FFF; }' +
				'div.origin-notice a.close { position: absolute; top: 2px; right: 5px; color: #FFF; font-weight: bold; text-decoration: none; }' +
				'</style>';
	$('head').append(css);

	// Include some CSS
	$.originNotice = function(options) {
		if (arguments.length == 2) {
			options = { type: arguments[0], message: arguments[1] };
		} else if (typeof options == 'string') {
			options = { message: options };
		}
		options = $.extend({ type: 'success', // 'error', 'info'
			message: 'Item was successfully added',
			css: null, // css({ position })
			timeout: 3000, //-1 Show forever
			closeButton: true, // Add a close 'x'

			remove: null,	// Remove event handler
			close: null,	// Close event handler
			click: null,	// Click event handler
			parent: null	// Parent node to append to
		}, options);

		var message = $('<div class="origin-notice"></div>')
							.html('<span>' + options.message + '</span>')
							.addClass('origin-notice-' + options.type)
							.css({ position: 'absolute', visibility: 'hidden' })
							.bind('noticeRemove', function() {
								if ($(this).is(':visible')) {
									$(this)[$(this).parent().is('#origin-notice-wrapper') ? 'slideUp' : 'fadeOut'](function() {
										var p = $(this).parent();
										$(this).remove();
										if (p.children().length == 0) {
											p.remove();
										}
									});
									return true;
								}
								return false;
							})
							.bind('click', function(evt) {
								if ($(evt.target).is('a.close')) {
									$(this)
										.trigger('noticeClose')
										.trigger('noticeRemove');
									return false;
								} else {
									$(this).trigger('noticeClick');
								}
							});
		if ($.isFunction(options.remove)) {
			message.bind('noticeRemove', options.remove);
		}
		if ($.isFunction(options.close)) {
			message.bind('noticeClose', options.close);
		}
		if ($.isFunction(options.click)) {
			message.bind('noticeClick', options.click);
		}
		if (options.closeButton) {
			message
				.addClass('origin-notice-close')
				.append('<a href="#" class="close">x</a>');
		}
		
		var parent = options.parent;
		if ( parent === null ) {
			if ( options.css === null ) {
				if ($('#origin-notice-wrapper').length == 0) {
					$('<div id="origin-notice-wrapper"></div>').appendTo('body');
				}
				parent = $('#origin-notice-wrapper');
				// Set the position back to inline
				message.css('position', '');
			} else {
				parent = $('body');
			}
		} else {
			parent = $(options.parent);
		}
		parent.append(message);
		if ( options.css !== null ) {
			if (!$.isFunction(options.css)) {
				message.css(options.css);
			} else {
				options.css.call(message[0]);
			}
		}
		
		if (options.timeout > 0) {
			message.wait(options.timeout, function() {
				$(this).trigger('noticeRemove');
			});
		}
		message
			.css({ display: 'none', visibility: '' })
			.fadeIn()
			.trigger('noticeAdded');

		return message.get();
	};

	$.fn.originNoticeRemove = function() {
		$(this).closest('div.origin-notice').trigger('noticeRemove');
		return this;
	};
	$.fn.originNoticeMessage = function(message) {
		$(this).closest('div.origin-notice').find('> span').fadeOut('fast', function() {
			$(this)
				.html(message)
				.fadeIn('fast');
		});
		return this;
	};
})(jQuery);

var OriginNotify = OriginNotify || {};

(function ($, window, undefined) {
	var displayTimer;

	OriginNotify.ShowNotification = function (params) {
	    // options array
	    var top;
	    if (params.isDetail == true) {
	        top = params.top;
	    } else {
	        top = 110;
	    }
	    var options = {
	        'top': top,
			'showAfter': 0, // number of sec to wait after page loads
			'duration': 5, // display duration
			'autoClose': true, // flag to autoClose notification message
			'type': 'success', // type of info message error/success/info/warning
			'message': '' // message to dispaly
		};

		if (typeof params == 'string') {
			options.message = params;
		} else {
			// Extending array from params
			$.extend(true, options, params);
		}

		var msgclass = 'succ_bg'; // default success message will shown
		if (options['type'] == 'error') {
			msgclass = 'error_bg'; // over write the message to error message
		} else if (options['type'] === 'information') {
			msgclass = 'info_bg'; // over write the message to information message
		} else if (options['type'] === 'warning') {
			msgclass = 'warn_bg'; // over write the message to warning message
		}

	    // Parent Div container
	    // Only create the message if it doesn't currently exist.
		var container = $('#info_message');

		if (container.length) {
            // It exists, so just modify our current instance.
		    container.addClass(msgclass);
		    container.find('.info_message_text').html(options['message']);
		} else {
            // Doesn't exist so create it.
		    container = '<div id="info_message" class="' + msgclass + ' style="top=' + options['top'] + 'px"><div class="info-container"><div class="info_message_text message_area">';
		    container += options['message'];
		    container += '</div><div class="info_close_btn button_area" onclick="return closeNotification()"></div><div class="clearboth"></div>';
		    container += '</div><div class="info_more_descrption"></div></div>';
		}


		// Appeding notification to Body
		$('body').append($(container));

		var divHeight = $('div#info_message').height();
		// see CSS top to minus of div height
		$('div#info_message').css({
			top: '-' + divHeight + 'px'
		});

		// showing notification message, default it will be hidden
		$('div#info_message').show();

		// Slide Down notification message after startAfter seconds
		OriginNotify.SlideDownNotification(options['showAfter'], options['autoClose'], options['duration'], options['top']);
	}

	OriginNotify.CloseNotification = function (duration) {
	    var divHeight = $('div#info_message').height();
	    displayTimer = setTimeout(function () {
	        $('#info_message').stop().animate({
	            top: '-' + divHeight
	        }, function () {
	            $('#info_message').remove();
	        });

	    }, parseInt(duration * 1000));
	}

	OriginNotify.SlideDownNotification = function (startAfter, autoClose, duration, top) {
	    setTimeout(function () {
	        clearTimeout(displayTimer);

	        $('#info_message').stop().animate({
	            top: top
	        });

	        if (autoClose) {
	            OriginNotify.CloseNotification(duration);

	            $('#info_message .info-container')
					.mouseenter(function () {
					    clearTimeout(displayTimer);
					}).mouseleave(function () {
					    OriginNotify.CloseNotification();
					});
	        }
	    }, parseInt(startAfter * 1000));
	}

})(jQuery, window);